import NavBar from "../../components/navigation";
import React from "react";
// import browseFile from "../../browseFile";
import TaskBoardPresenter from "./TaskBoardPresenter";
// import Calendar from "../../components/calendar/Calendar";
import CardView from "../../components/common/CardView";
import events from "../../images/noData.svg";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
// import { formatDate } from "../../components/common/Converter";
// import { Progress } from "antd";
import ForProcessing from "./ProgressRequest/ForProcessing";
// import icon from "../../images/events.svg";

class TaskBoard extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TaskBoardPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = { objects: [], combined: [] };
  }

  // async componentDidMount() {
  //   this.presenter.componentDidMount();
  //   this.fetchData();
  // }

  // async fetchData() {
  //   this.setState({ isLoading: true });
  //   const userID = this.getCurrentUser().id;

  //   try {
  //     const [Approver, Rejector, Request] = await Promise.all([
  //       findObjectUseCase().execute(this.getCollectionName(), {
  //         where: {
  //           workFlow: {
  //             "tasks.0.hierarchy.approve.id": userID,
  //           },
  //           stats: "Pending",
  //         },
  //         include: ["workFlow", "employee"],
  //       }),
  //       findObjectUseCase().execute(this.getCollectionName(), {
  //         where: {
  //           workFlow: {
  //             "tasks.0.hierarchy.reject.id": userID,
  //           },
  //           stats: "Pending",
  //         },
  //         include: ["workFlow", "employee"],
  //       }),
  //       findObjectUseCase().execute(this.getCollectionName(), {
  //         where: {
  //           workFlow: {
  //             "tasks.0.hierarchy.request.id": userID,
  //           },
  //           stats: "Pending",
  //         },
  //         include: ["workFlow", "employee"],
  //       }),
  //     ]);
  //     const combined = [...Approver, ...Rejector, ...Request];
  //     this.setState({ combined });
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     this.setState({ isLoading: false });
  //   }
  // }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  getCollectionName() {
    return "requests";
  }

  processBoard(title, children) {
    return (
      <div className="col-lg-4 mb-3">
        <CardView
          style={{
            backgroundColor: "rgb(58, 98, 175)",
            borderRadius: 0,
          }}
        >
          <span className="text-white">{title}</span>
          <hr />
          <div className="h-100">{children}</div>
        </CardView>
      </div>
    );
  }

  getCurrent() {
    return this.getCurrentUser();
  }

  render() {
    const { objects } = this.state;
    console.log("OBJECTS: ", objects);
    return (
      <>
        <div
          className={`container-fluid d-flex flex-column ${
            this.isMobile() ? "pt-5" : "p-5"
          }`}
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Tasks &gt;{" "}
              <span style={{ color: "#333" }}>Approval</span>
            </p>
          </div>

          <div className="row align-items-start">
            {this.processBoard(
              "For Processing",
              objects.length === 0 ||
                objects.every((object) => object.stats !== "Pending") ? (
                <div className="d-grid justify-content-center align-items-center h-100 text-center p-2 bg-white">
                  <img width="120" src={events} alt="No Data" />
                  <p style={{ fontSize: "14px" }}>No Data</p>
                </div>
              ) : (
                <ForProcessing
                  objects={objects.filter(
                    (object) => object.stats === "Pending"
                  )}
                  currentUser={this.getCurrentUser()}
                  fetchData={() => this.refetchData()}
                />
              )
            )}

            {/*Cardview 2*/}
            {this.processBoard(
              "In-Progress",
              objects.length === 0 ||
                objects.every(
                  (object) =>
                    !["In-Progress", "Approved"].includes(object.stats)
                ) ? (
                <div className="d-grid justify-content-center align-items-center h-100 text-center p-2 bg-white">
                  <img width="120" src={events} alt="No Data" />
                  <p style={{ fontSize: "14px" }}>No Data</p>
                </div>
              ) : (
                <ForProcessing
                  objects={objects.filter((object) =>
                    ["In-Progress", "Approved"].includes(object.stats)
                  )}
                  currentUser={this.getCurrentUser()}
                  fetchData={() => this.refetchData()}
                />
              )
            )}
            {/*Cardview 3*/}
            {this.processBoard(
              "Done",
              objects.length === 0 ||
                objects.every(
                  (object) => !["Done", "Rejected"].includes(object.stats)
                ) ? (
                <div className="d-grid justify-content-center align-items-center h-100 text-center p-2 bg-white">
                  <img width="120" src={events} alt="No Data" />
                  <p style={{ fontSize: "14px" }}>No Data</p>
                </div>
              ) : (
                <ForProcessing
                  objects={objects.filter((object) =>
                    ["Done", "Rejected"].includes(object.stats)
                  )}
                  currentUser={this.getCurrentUser()}
                  fetchData={() => this.refetchData()}
                  processStatus="Done"
                />
              )
            )}
          </div>
        </div>
      </>
    );
  }
}

export default TaskBoard;
